import Vue from 'vue';
import { initMatomo } from './plugins/matomo';

import Pui9Login from '@Pui9Login';
import { Pui9LoginCheckerMixin } from '@Pui9Login';
import Pui9Menu from '@Pui9Menu';
import Pui9Notify from '@Pui9Notifications';
import Pui9HttpRequests from '@Pui9Requests';
//import Pui9WebSockets from '@Pui9Websockets';
import Pui9Datatables from '@Pui9Datatables';
import Pui9Components from '@Pui9Components';
import Pui9Base from '@Pui9Base';
import Pui9Admin from '@Pui9Admin';
import Pui9Docgen from '@Pui9Docgen';
import Pui9Documents from '@Pui9Documents';
//import Pui9Dashboard from '@Pui9Dashboard';


import store from './store/store';
import router from './router/router';
import i18n from './i18n/i18n';
import vuetify from './plugins/vuetify';
import puiEventsBus from './bus';
import beforeRun from './beforeRun';

import App from './App.vue';

import '@fortawesome/fontawesome-pro/css/all.css';
import 'vuetify/dist/vuetify.min.css';

import 'pui9-styles/pui9.css';
import 'pui9-login/dist/pui9-login.css';
import 'pui9-datatables/dist/pui9-datatables.css';
import 'pui9-base/dist/pui9-base.css';
import 'pui9-docgen/dist/pui9-docgen.css';
import 'pui9-documents/dist/pui9-documents.css';

import './styles/app.css';

Vue.config.productionTip = false;

function defineGlobalPlugins() {
	Vue.use(Pui9Login);
	Vue.use(Pui9Menu);
	Vue.use(Pui9Notify);
	Vue.use(Pui9Datatables);
	Vue.use(Pui9Components);
	Vue.use(Pui9Base);
	Vue.use(Pui9Admin);
	Vue.use(Pui9Docgen);
	Vue.use(Pui9Documents);
	initMatomo();

	Object.defineProperty(Vue.prototype, '$puiRequests', { value: Pui9HttpRequests });
	Object.defineProperty(Vue.prototype, '$puiEvents', { value: puiEventsBus });
	Object.defineProperty(Vue.prototype, '$puiI18n', { value: i18n });
}

function defineGlobalMixins() {
	Vue.mixin(Pui9LoginCheckerMixin(store, Pui9HttpRequests));

}


function setLanguage() {
	i18n.locale = window.localStorage.getItem('pui9_lang') || store.state.global.defaultAppLang;

}


(async () => {
	puiEventsBus.$on('onPuiChangedLang', lang => {
		i18n.locale = lang;
	});

	Pui9HttpRequests.setStore(store);

	defineGlobalPlugins();
	defineGlobalMixins();
	setLanguage();

	await beforeRun();

	const vm = new Vue({
		vuetify,
		store,
		router,
		i18n,
		render: h => h(App)
	});

	store.$app = vm;

	vm.$mount('#app');
})();
